export const BASIC_ACTIVATION_AMOUNT = 3500;
export const ENTERPRISE_ACTIVATION_AMOUNT = 4500;
export const REACTIVATION_AMOUNT = 2500;
